import { UserRole } from '@/modules/common/types';

export const DEFAULT_NEW_APP_ROUTE = '/home';

export function roleFallback(role?: UserRole, isNewVersion = true) {
  switch (role) {
    case UserRole.SUPER:
      return '/super';
    case UserRole.ADMIN:
      return isNewVersion ? DEFAULT_NEW_APP_ROUTE : '/';
    case UserRole.VIEWER:
      return isNewVersion ? DEFAULT_NEW_APP_ROUTE : '/';
    case UserRole.EMPLOYEE:
      return isNewVersion ? DEFAULT_NEW_APP_ROUTE : '/data-management';
    case UserRole.EXTERNAL:
      return isNewVersion ? '/reporting' : '/shareable';
    case UserRole.STAKEHOLDER:
      return '/materiality-assessment/evaluation-request';
    default:
      return DEFAULT_NEW_APP_ROUTE;
  }
}
